import React, { FunctionComponent } from 'react';
import { IActionButtonsDisplayConfig } from '../ActionButtonsContainer';
import PlatformSave from './PlatformSave';
import IActionButtonProps from '../IActionButtonProps';

function shouldBeSavedInPlatform(config: IActionButtonsDisplayConfig): boolean {
  return config.isSaveOfferEnabled === true && config.externalSaveOffer === false;
}

const SaveButtonContainer: FunctionComponent<IActionButtonProps> = ({ config }) => {
  if (shouldBeSavedInPlatform(config)) {
    return <PlatformSave config={config} />;
  }

  return null;
};

export default SaveButtonContainer;
